import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'NjRhZGMxNDBmMWQwODVhNTY4MTUzZGVhOThmMWMyOTQ=',
  'Tenant-Access-Key': 'tsSa8nojBAPAuQ',
};

export const api = axios.create({
  baseURL: 'https://immersive-game-india.confirmu.com',
  headers: {
    'Tenant-Access-Token': 'NjRhZGMxNDBmMWQwODVhNTY4MTUzZGVhOThmMWMyOTQ=',
    'Tenant-Access-Key': 'tsSa8nojBAPAuQ',
  },
});

export const BASE_URL = 'https://immersive-game-india.confirmu.com';
